import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'libphonenumber-js';

@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    return format(value || '', 'AU', 'National');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/phone-number.pipe.ts